import { nonInterceptedClient } from './axios'

export const login = (username, password) => {
  return nonInterceptedClient.post('user/login/', { username, password })
}
